import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import WelcomeSection from '../components/WelcomeSection';
import FeedbackSection from '../components/FeedbackSection';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <HeroSection />
      <WelcomeSection />
      <FeedbackSection />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default HomePage;
